import { render, staticRenderFns } from "./GTNewsPortalCreate.vue?vue&type=template&id=0d46e6a0&scoped=true"
import script from "./GTNewsPortalCreate.vue?vue&type=script&lang=js"
export * from "./GTNewsPortalCreate.vue?vue&type=script&lang=js"
import style0 from "./GTNewsPortalCreate.vue?vue&type=style&index=0&id=0d46e6a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d46e6a0",
  null
  
)

export default component.exports